import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Check from '@material-ui/icons/Check';

import CircularBadge from 'components/common/Badge/CircularBadge';
import { isAssessmentSubmitted } from 'selectors/assessment/selector';

import { MobileSideBar } from 'components/common/SideBar/MobileSideBar/MobileSideBar';
import './Header.scss';

export const AssessmentHeader = props => {
  const {
    assessment,
    assessmentHelpText,
    assessmentProgress,
    currentUser,
    assessmentAnsweredQuestions,
    assessmentTotalQuestions,
    participantsData,
    isAssessmentDisabled,
    isOwner,
    onDeleteUser,
    onUpdateUser,
    filterVariables,
    setTriggerGuidedTour,
    actions,
    selectedCategory,
    visibleCategory,
    currentCategory,
    activeUsers
  } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <span className="mobile-menu-sidebar">
        <MobileSideBar
          submitted={isAssessmentSubmitted(assessment.status)}
          isAssessmentPage
          assessmentProgress={assessmentProgress}
          assessment={assessment}
          assessmentHelpText={assessmentHelpText}
          t={t}
          className="mobile-menu-sidebar"
          currentUser={currentUser}
          assessmentAnsweredQuestions={assessmentAnsweredQuestions}
          assessmentTotalQuestions={assessmentTotalQuestions}
          participantsData={participantsData}
          isAssessmentDisabled={isAssessmentDisabled}
          isOwner={isOwner}
          onDeleteUser={onDeleteUser}
          onUpdateUser={onUpdateUser}
          filterVariables={filterVariables}
          setTriggerGuidedTour={setTriggerGuidedTour}
          actions={actions}
          selectedCategory={selectedCategory}
          visibleCategory={visibleCategory}
          currentCategory={currentCategory}
          activeUsers={activeUsers}
        />
      </span>

      <div className="assessment-info">
        <div className="right-block info-content">
          {isAssessmentSubmitted(assessment.status) && (
            <span className="submitted">
              <CircularBadge value={<Check />} />
              {t('common.submitted')}
            </span>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

AssessmentHeader.propTypes = {
  // TODO: Fix this...
  // eslint-disable-next-line react/forbid-prop-types
  assessment: PropTypes.object.isRequired
};

export default AssessmentHeader;
